import { FC, useContext } from "react";
import { GBP_SYMBOL } from "lib/constants";
import FlexBox from "../flex-box";
import SimpleCard from "../simple-card";
import SimpleButton from "../simple-button";
import { formatDate, toFormattedDate, formatDateUTCwithoutDay, toFormattedDateUTC } from "lib/utils/date-utils";
import { AppContext } from "lib/contexts/app-context";

interface PatientMembershipPackageSummaryTileProps {
  id: string;
  name: string;
  credits: number; // smallint, default 0
  subscribeDate: string;
  nextInvoiceDate: string;
  price: number;
  patientId: string;
  status?: string;
  onChangePatientMembershipPackageStatus?: (patientMembershipPackageId: string, status?: string) => void;
}

const PatientMembershipPackageSummaryTile: FC<PatientMembershipPackageSummaryTileProps> = ({
  id,
  name,
  credits,
  subscribeDate,
  nextInvoiceDate,
  price,
  status,
  patientId,
  onChangePatientMembershipPackageStatus,
}) => {
  const { appState } = useContext(AppContext);
  const userRole = appState?.userRole;
  return (
    <SimpleCard className="rounded">
      <FlexBox justifyContent="center" alignItems="start" direction="column">
        
        <FlexBox justifyContent="between" alignItems="center">
          <small>Name:</small>
          <small>
            <strong>{name}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Credits:</small>
          <small>
            <strong>{credits} credits</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Subscribe Date:</small>
          <small>
            <strong>{formatDateUTCwithoutDay(subscribeDate)}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Next Invoice Date:</small>
          <small>
            <strong>{formatDateUTCwithoutDay(nextInvoiceDate)}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Price:</small>
          <small>
            <strong>{GBP_SYMBOL}&nbsp;{price}</strong>
          </small>
        </FlexBox>

        <FlexBox justifyContent="between" alignItems="center">
          <small>Status:</small>
          <small>
            <strong>{status}</strong>
          </small>
        </FlexBox>
        
        <hr />
        <FlexBox>
          {status !== 'cancelled' && (
            <SimpleButton onClick={() => onChangePatientMembershipPackageStatus?.(id, 'cancelled')}>
              Cancel
            </SimpleButton>
          )}
        </FlexBox>
      </FlexBox>
    </SimpleCard>
  );
};

export default PatientMembershipPackageSummaryTile;
